<template lang="pug">
el-container.main
    .main-header
        .main-breadcrumb
            el-page-header(content="团队成员" @back="back")
        .main-action
            el-button(type="primary", size="small", @click="show('InviteVisible')") 邀请
    template(v-if="teamMembers.length === 0")
        .main-content
            .block
                span 尚无成员
    template(v-else)
        .main-content
            el-table(v-bind:data="teamMembers" :header-cell-style="tableHeaderColor")
                el-table-column(prop="user.name" label="账号")
                el-table-column(prop="user.displayName", label="展示名")
                el-table-column(prop="teamRole" label="团队角色" width="120" :formatter="displayRoleCNName")
                el-table-column(prop="user.email", label="邮箱")
                el-table-column(label="操作" width="180")
                    template(slot-scope="scope")
                        el-button(type="text", @click="editRoleReset(scope.row)") 重置角色
                        el-button(type="text", @click="deleteMember(scope.row.user.name)") 移除
        .main-pager
            el-pagination.page(background, layout='prev, pager, next', :page-count='page.total', :current-page='page.number', @current-change='currentChange')

    Invite(:visible="display.InviteVisible" :teamId="teamId" @hide="hideInvite" @refresh="refresh")
    RoleReset(:visible="display.RoleResetVisible" :editing="editing" :teamId="teamId" @hide="hideRoleReset" @refresh="refresh")
</template>

<script>
import {
  getUserOrgsAPI,
  listTeamMembersAPI,
  deleteTeamMemberAPI
} from "@/services"
import Invite from "./Invite"
import RoleReset from "./RoleReset.vue"

export default {
  name: "TeamMemberDetail",
  components: { Invite, RoleReset },
  props: ["teamId"],
  data() {
    return {
      loading: false,
      search: "",
      page: {
        total: 1,
        number: 1
      },
      org: {},
      editing: null,
      display: {
        InviteVisible: false,
        RoleResetVisible: false
      },
      team: [],
      teamMembers: [],
      teamRoleOptions: [
        {
          value: "admin",
          label: "团队管理员"
        },
        {
          value: "member",
          label: "团队成员"
        }
      ]
    }
  },
  methods: {
    /**
         * Backend Service API Function Wrapper
         */
    async listTeamMembers() {
      this.loading = true
      try {
        const res = await listTeamMembersAPI(
          this.teamId,
          this._.pickBy(this.page, this._.identity)
        )
        if (res.status === 200) {
          this.teamMembers = res.data.data
          this.page = {
            total: res.data.total,
            number: res.data.number
          }
        } else {
          throw err
        }
      } catch (err) {
        console.log("获取组织成员列表失败")
        this.$message.error("服务器开小差了，请尝试重新操作")
      } finally {
        this.loading = false
      }
    },
    async deleteMember(username) {
      this.loading = true
      try {
        const res = await deleteTeamMemberAPI(this.teamId, username)
        if (res.status === 204) {
          this.refresh()
          this.$message.info("移除成功")
        } else {
          throw err
        }
      } catch (err) {
        console.log("移除团队成员失败")
        this.$message.error("服务器开小差了，请尝试重新操作")
      } finally {
        this.loading = false
      }
    },
    /**
         * UI Interaction
         */
    show(name) {
      this.display[name] = true
    },
    hide(name) {
      this.display[name] = false
    },
    refresh() {
      this.listTeamMembers()
    },
    hideInvite() {
      this.hide("InviteVisible")
      this.editing = null
    },
    hideRoleReset() {
      this.hide("RoleResetVisible")
      this.editing = null
    },
    editRoleReset(member) {
      this.show("RoleResetVisible")
      this.editing = member
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;color: #8493A8;"
      }
    },
    dateFormat(row, column) {
      const date = row[column.property]
      return moment(date).format("YYYY-MM-DD HH:mm:ss")
    },
    back() {
      this.$router.push({ name: "team" })
    },
    currentChange(number) {
      this.page.number = number
      this.listTeamMembers()
    },
    displayRoleCNName(row) {
      if (row.teamRole === "admin") {
        return "管理员"
      } else if (row.teamRole === "member") {
        return "普通成员"
      } else {
        return row.teamRole
      }
    }
  },
  mounted() {
    this.listTeamMembers()
  }
}
</script>
<style lang="stylus" scoped>
.block {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin: 10px;
    padding: 20px;
    border: dashed 1px #bbbbbb;
    border-radius: 15px;

    span {
        margin: auto;
    }

    .el-input {
        width: 360px;
    }
}
</style>
